import Axios from "axios";
export const PostAddPromotionToGroup = async (idGroup, concept, type_promotion, percentage, date_begin, date_end) => {
    try {
        const res = await Axios.post(process.env.REACT_APP_API_URL + "postAddPromotionToGroup/", {
            idGroup, concept, type_promotion, percentage, date_begin, date_end
        }, {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
        return res.data
    } catch (error) {
        console.log(error)
    }
}

export const EditUnitTeacherClasses = async (fk_subsidiary)=>{
    try {
        const res = await Axios.patch(process.env.REACT_APP_API_URL + "editUnitTeacherClasses/", {
            fk_subsidiary
        }, {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
        return res.data
    } catch (error) {
        console.log(error)
    }
}
export const GetUnitLimitsGroup = async (fk_subsidiary)=>{
    try {
        const res = await Axios.post(process.env.REACT_APP_API_URL + "getUnitLimitsGroup/", {
            fk_subsidiary
        }, {
            headers: {
                "x-access-token": localStorage.getItem("token"),
            },
        })
        return res.data
    } catch (error) {
        console.log(error)
    }
}

